import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { timestamps } from "../utils/fields";

// Durable cache for react-query responses. One row per stable-stringified
// queryKey. The data column is heterogeneous across rows; type narrowing
// happens at the helper boundary (utils/durableCache).
export const queryCache = sqliteTable("query_cache", {
  ...timestamps,
  queryKey: text("query_key").primaryKey(),
  data: text("data", { mode: "json" }).notNull().$type<unknown>(),
  fetchedAt: integer("fetched_at", { mode: "timestamp_ms" }).notNull(),
});

export type QueryCacheRow = typeof queryCache.$inferSelect;
